import { render, staticRenderFns } from "./activity-formula-form.vue?vue&type=template&id=1b9817b8&"
import script from "./activity-formula-form.vue?vue&type=script&lang=ts&"
export * from "./activity-formula-form.vue?vue&type=script&lang=ts&"
import style0 from "./activity-formula-form.vue?vue&type=style&index=0&lang=scss&_scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports